import React from "react";
import { connect } from "react-redux";
import "./privacy.style.scss";
import { Typography } from "@mui/material";

export type Props = {};

function PolicyPage() {
  return (
    <div className="privacy">
      <main>
      <section id="privacy-policy">
            <Typography variant="h2" sx={{fontSize:"32px", fontWeight:"600"}}>Privacy Policy</Typography>
            <p>Welcome to Croqee! Our Privacy Policy explains how we collect, use, and share information about you when you use our application and its related services (collectively, the "Service"). By engaging with our Service, you consent to the practices described in this policy.</p>

            <h3>Information Collection and Use</h3>
            <p>To provide you with a personalized and efficient experience, we collect various types of information:</p>
            <ul>
                <li><strong>Personal Data:</strong> We collect your name and email address, which are essential for account registration, communication, and support purposes. Your name is used to personalize your experience within our Service. Both your name and email address are also used for our own advertising or marketing purposes with your consent. Furthermore, these pieces of information are linked to your identity and may be used for tracking purposes to improve service delivery and for analytical purposes aimed at enhancing our Service's functionality and the relevance of our marketing efforts.</li>
                <li><strong>Device Information:</strong> We collect information about the devices you use to access our Service, such as hardware models and operating system versions. This helps us optimize our Service for your device's capabilities and preferences.</li>
                <li><strong>Cookies and Similar Technologies:</strong> Our Service uses cookies and similar technologies to remember your preferences, authenticate your account, and provide a seamless experience. You have the option to disable cookies through your browser settings, though some features of our Service may not function properly as a result.</li>
                <li><strong>Authentication Tokens:</strong> For security purposes and to maintain your session, we use authentication tokens. These tokens facilitate your access to our Service without requiring repeated logins.</li>
                <li><strong>Additional Information:</strong> After registering, you have the option to provide additional information about your location, art profiles, and portfolio links. This information is used to tailor our marketing efforts and to gain a better understanding of our target audience. Your provision of this information is entirely voluntary and helps us to offer a more personalized experience.</li>
            </ul>

            <h3>How We Use Your Information</h3>
            <p>The information we collect helps us deliver, maintain, and improve our Service. Specifically, we use your data to:</p>
            <ul>
                <li>Provide, operate, and maintain our Service</li>
                <li>Improve your interaction with our Service, including tailoring features and content</li>
                <li>Develop new products, services, features, and functionality</li>
                <li>Communicate with you, including for customer service, updates, and promotional purposes, directly relating to your name and email address for personalized communication and marketing.</li>
                <li>Ensure the security of our Service, including fraud monitoring and prevention</li>
                <li>Analyze the use of our Service to understand and engage our target audience more effectively.</li>
            </ul>

            <h3>Sharing Your Information</h3>
            <p>We do not share your personal information with third parties except as necessary to provide our Service, comply with the law, or protect our rights. Your name and email address may be used internally for promotional purposes and, with your consent, for marketing communications. Additional information you choose to provide is used for marketing purposes and to better understand our target audience. We may share aggregated, non-personally identifiable information with partners or for research purposes.</p>
        </section>

        <section id="terms-and-conditions">
          <Typography
            variant="h2"
            sx={{ fontSize: "32px", fontWeight: "600", marginTop: "64px" }}
          >
            Terms and Conditions
          </Typography>
          <p>
            These Terms and Conditions govern your use of Croqee and the
            services we offer. By accessing or using our Service, you agree to
            be bound by these terms.
          </p>

          <h3>Use of Service</h3>
          <p>
            Croqee provides a platform for learning anatomy, drawing, and
            participating in competitive drawing challenges. You agree to use
            our Service for its intended purposes and not engage in any activity
            that could harm our Service or other users.
          </p>

          <h3>User Content</h3>
          <p>
            You may create, upload, share, and participate in content related to
            drawing and competitions. You retain all rights to your content but
            grant us a license to use it for the operation of our Service. We do
            not claim ownership of your content.
          </p>

          <h3>Competitions and Scoring</h3>
          <p>
            Participation in competitions is governed by the rules set forth for
            each event. Scores are determined based on accuracy and adherence to
            competition guidelines. We reserve the right to adjust scoring
            criteria as needed.
          </p>

          <h3>Accounts and Security</h3>
          <p>
            You are responsible for maintaining the confidentiality of your
            account and password. You agree to notify us immediately of any
            unauthorized use of your account.
          </p>

          <h3>Changes to Terms and Conditions</h3>
          <p>
            We reserve the right to modify these terms at any time. You are
            advised to review the terms periodically for any changes.
          </p>
        </section>
      </main>
    </div>
  );
}

export default connect(null, {})(PolicyPage);
